export const SDK_VERSION = '0.1.0';

export const STORAGE_PREFIX = 'veridion_';
export const SUBJECT_ID_KEY = `${STORAGE_PREFIX}subject_id`;
export const BANNER_DISMISSED_KEY = `${STORAGE_PREFIX}banner_dismissed`;

export const SDK_KEY_HEADER = 'X-Veridion-Key';

export const SHADOW_HOST_TAG = 'veridion-consent';
